import { Box, Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

type OpenPdfFeedbackProps = {
  src: string;
};

const Background = withStyles(Box, (theme) => ({
  root: {
    background: theme.palette.background.default,
  },
}));

const OpenPdfFeedback = ({ src }: OpenPdfFeedbackProps) => {
  const { translate } = useTranslation();
  const openInNewTab = () => {
    const newWindow = window.open(src, '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  return (
    <Background width="100%" height="100%" display="flex" alignItems="center">
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button variant="text" color="secondary" onClick={openInNewTab}>
          {translate(LangEnum.CATALOGS_CLICK_HERE_TO_OPEN)}
        </Button>
      </Box>
    </Background>
  );
};

export default OpenPdfFeedback;
